import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	cadastraGrupoCarga,
	deleteGrupoCargaPorId,
	editaGrupoCargaPorId,
	getGrupoCarga,
	getGrupoCargaPorId,
} from "../../../services/ModuloGerenciador/GrupoCarga";
import "./GrupoCarga.css";

function GrupoCarga(props) {
	const { profile, tabelaEmpresa, hasRegra } = useProfile();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState();

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarGrupoCarga = async () => {
		setLoading(true);
		await getGrupoCarga(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.nomeGrupo !== "" && validator.nomeGrupo === "true") {
			setLoading(true);
			await cadastraGrupoCarga(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarGrupoCarga();
						setDadosRequestControllerRedux("Fechar Modal GrupoCarga");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaGrupoCargaPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarGrupoCarga();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarGrupoCargaPorId = async () => {
		setLoading(true);
		await getGrupoCargaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarGrupoCargaPorIdModal = async (id) => {
		setLoading(true);
		await getGrupoCargaPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarGrupoCargaPorId = async () => {
		setLoading(true);
		await deleteGrupoCargaPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarGrupoCarga();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Grupo Carga";
		if (telaCadastro) return "Cadastro de Grupo Carga";
		return "Grupo Cargas";
	}, [editando, telaCadastro]);

	useEffect(() => {
		setValidator((current) => ({ ...current, nomeGrupo: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando && profile?.token) {
			buscarGrupoCargaPorId();
		}
	}, [editando, profile?.token]);

	useEffect(() => {
		if (props.idAtual) {
			buscarGrupoCargaPorIdModal(props.idAtual);
		}
	}, [props.idAtual]);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Grupo Cargas"));
			buscarGrupoCarga();
		}
	}, [profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="GrupoCargaContainer">
						<div className="content-container">
							<Separator size="xl" />
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.GrupoCarga}
								dados={dadosTabela}
								isLoading={loading}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="GrupoCargaCadastroContainer">
						{!props.desabilitar ? (
							<div className="indicadores">
								<div className="texto-cadastro">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<p className="indicador-emb">{"Dados de Grupo Cargas / "}</p>
									{editando ? (
										<p className="indicador-emb">
											{"Detalhes de Grupo Cargas"}
										</p>
									) : (
										<p className="indicador-emb">
											{"Cadastro de Grupo Cargas"}
										</p>
									)}
									<HeaderCadastro texto="" />
								</div>
								{props.botaoFechar !== false && (
									<div className="close-btn">
										<CloseIcon
											onClick={() => {
												setValues({});
												setTelaCadastro(false);
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								)}
							</div>
						) : (
							<></>
						)}
						<div className="flex-column">
							<div className="container-select-emb">
								<div className="rota-div-2">
									<div className="coluna-emb">
										<div className="principal">
											<p className="input-label-emb" htmlFor="descricao">
												Nome:
											</p>
											<input
												type="text"
												className="input-emb"
												style={{ width: "270px" }}
												onChange={(e) => {
													setValues((current) => ({
														...current,
														nomeGrupo: e.target.value,
													}));
													setValidator((current) => ({
														...current,
														nomeGrupo: "true",
													}));
												}}
												placeholder="Ex: Grupo 1"
												value={values.nomeGrupo}
												disabled={props.desabilitar}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="botoes-embalagem">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
										setTelaCadastro(false);
										setEditando(false);
										setValues({});
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.nomeGrupo !== "" &&
														validator.nomeGrupo === "true"
													) {
														cadastrar();
														setValues({});
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.nomeGrupo !== "" &&
														validator.nomeGrupo === "true"
													) {
														cadastrar();
														setValues({});
														setTelaCadastro(false);
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarGrupoCargaPorId}
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default GrupoCarga;
